export default class Capacity {
	constructor({id, name, description, visit_points, resources}) {
		this.id = id || 0;
		this.name = name || "";
		this.description = description || "";
		this.visit_points = visit_points || [];
	}
}
